<template>
  <div class="">
    <div
      class="d-flex flex-column px-12 py-3 rounded-top justify-content-between align-items-center bg-leader"
      :class="leader ? 'bg-leader' : 'bg-deputy-leader'"
      style="width: 327px; height: 98px">
      <div class="d-flex font-size-16 fw-semibold mt-1">
        <span class="font-14 fw-500 text-white mt-5">
          {{ content.title }}
        </span>
      </div>
    </div>
    <div
      class="font-12 fw-300 text-grey600 text-center px-2 rounded-bottom"
      style="background-color: white; max-width: 327px">
      {{ content.description }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatECardGroupAuthor",
  props: ["thumb", "content", "href", "conversation"],
  computed: {
    currentAcc() {
      const currentAcc = this.app.accounts.find((a) => a.accountId === this.conversation.accountId);
      return currentAcc;
    },
    leader() {
      if (this.content.title && this.content.title.includes("trưởng")) {
        return true;
      } else return false;
    },
  },
};
</script>

<style scoped>
.bg-leader {
  background-image: url("/assets/images/bg-group-leader.svg");
  background-size: contain;
}
.bg-deputy-leader {
  background-image: url("/assets/images/bg-group-deputy.svg");
  background-size: contain;
}
</style>